import ApplicationController from './application_controller'
import { readClickIds } from '../lib/ad_attribution'
import { marketingConsentGranted } from '../lib/marketing_consent'

// Fills its own hidden inputs from sessionStorage/URL, but only when a current local
// marketing consent grant exists. Same-origin now, so the grant is read directly. The
// gate is evaluated once per connect; fillFields needs no re-check because the grant
// event fires only after consent is recorded.
export default class extends ApplicationController {
  static targets = ['field']

  connect() {
    const effective = marketingConsentGranted()
    if (effective) {
      this.fillFields()
      return
    }
    this._onGrant = () => this.fillFields()
    document.addEventListener('marketing-consent:granted', this._onGrant, { once: true })
  }

  disconnect() {
    if (this._onGrant) document.removeEventListener('marketing-consent:granted', this._onGrant)
  }

  fillFields() {
    try {
      const clickIds = readClickIds()
      for (const field of this.fieldTargets) {
        const value = clickIds[field.dataset.adAttributionKey]
        if (value) field.value = value
      }
    } catch (error) {
      this.reportError(error, { source: 'ad_attribution_fields' })
    }
  }
}
